import React, { SVGProps } from 'react';

export default function TwilioLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" viewBox="0 0 92 84">
      <rect id="Rectangle_3" data-name="Rectangle 3" width="0" height="0" fill="#282a2b" />
    </svg>
  );
}
